/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import base64Encode from '../../../shared/base64encoder';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

export const uploadDocsFile = async (
  file: any,
  type: string,
  facility?: string,
  year?: string
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  const companyId = useCompanyStore.getState().companyId;
  const companyDetails = useCompanyStore.getState().companyDetails;

  const userDetails = useUserStore.getState().userDetails;

  try {
    const res = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.uploadDocsFile}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        file: await base64Encode(file).then((result) => {
          return result;
        }),
        company: companyId,
        type,
        facility: facility ?? '',
        fileName: file.name,
        user: userDetails._id,
        subCategory: companyDetails.subCategory,
        year: year ?? ''
      }
    });

    return res.data;
  } catch (err) {
    return err;
  }
};

export const uploadDocumentRecord = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const res = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.AIDocumentManager}/${getRouteIP(
        type,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    return res.data;
  } catch (err) {
    return err;
  }
};

export const updateReferenceRecordId = async (
  id: string = '',
  refId: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const res = await axios.request({
      method: tableAPIMethod(APITypeEnum.PUT),
      url: `${API_BASE_URL}${
        API_ENDPOINT_JSON.AIDocumentUpdateReferenceRecordId
      }/${getRouteIP(APITypeEnum.PUT, id)}/${refId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: {}
    });

    return res.data;
  } catch (err) {
    return err;
  }
};
